<template>
    <v-app>
        <app-navigation></app-navigation>
        <!-- <v-content transition="slide-x-transition"> -->
        <!-- v-content al parecer está deprecated... -->
        <v-main transition="slide-x-transition">
            <router-view></router-view>
        </v-main>
    </v-app>
</template>

<script>
import AppNavigation from '@/components/AppNavigation';

export default {
    name: 'App',
    data: () => ({}),
    components: {
        AppNavigation,
    },
    created() {}
};
</script>


<style>
/* .main-layout {
    width: 100%;
    height: 100%;
} */
</style>
